import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';


@Component({
  selector: 'app-patient-registration-zone-wise',
  templateUrl: './patient-registration-zone-wise.component.html',
  styleUrls: ['./patient-registration-zone-wise.component.scss']
})
export class PatientRegistrationZoneWiseComponent implements OnInit {
  public link: string = 'https://www.clickdimensions.com/links/TestPDFfile.pdf';
  fileName= 'ExcelSheet.xlsx';  
  showspinner = false;
  patientcount;
  dataSource = new MatTableDataSource<PatientDetailModel>();
  startdate;
  enddate;
  flag=1;
  pname = "";
  pageHeading:any;
  isShowDivIf:boolean = false;
  groupingColumn;
  reducedGroups = [];

  initialData: any [];
  constructor(public opdvisitService: OpdVisitService,
    public datepipe: DatePipe,
    public dashboardService: DashboardService,private exportdata:ExportService) { }
    displayedColumns: string[] = ['PatientId', 'RegDate', 'FirstName', 'LastName','Email','Address','City','State','Country','Gender','OldMrNo',
   'Dob','MobNo'];
  ngOnInit(): void {

    this.pageHeading = 'Patient Register Zone Wise'
  }
     
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
   
  }

  toggleDisplayDivIf() {
    this.isShowDivIf = !this.isShowDivIf;
  }

  gettop_200byname(pname: string){
    if(pname){
      this.showspinner = true;
      this.dataSource.data = [];

      this.opdvisitService.get_top200_byname(pname).subscribe(
        data => this.successtop200(data), err => this.failedtop200(err)
      )
} 
else{
  this.dashboardService.openSnackBar("Please Enter Name First", "Ok");
}

  
  }
  successtop200(data){
    this.showspinner = false;
    this.opdvisitService.patients = [];
    this.opdvisitService.patients = data;
    this.dataSource.data = this.opdvisitService.patients;
   this.patientcount = this.opdvisitService.patients.length;
   // alert("api working");
  }

  failedtop200(err){
    // alert("api failed");
  }
   
  get_records_between_two_dates(){

    this.showspinner = true;
    this.dataSource.data = [];
   // this.dashboardService.selecteddate = this.datePipe.transform(selecteddate, "yyyy-MM-dd");
    let sdate = this.datepipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datepipe.transform(this.enddate, "yyyy-MM-dd");
    if(this.flag==1){
      var Flag='CITY';
      this.groupingColumn="City";
    }else if(this.flag==2){
      var Flag='STATE';
      this.groupingColumn="State";
    }else if(this.flag==3){
      var Flag='COUNTRY';
      this.groupingColumn="Country";
    }else if(this.flag==4){
      var Flag='ALCSC';
      this.groupingColumn="";
    }else{
      var Flag='CITY';
    }
    
   this.opdvisitService.get_Zone_data_sdate_edate(sdate,edate,Flag).
   subscribe(data => this.success_Zone_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
 }
 newdata=[];
 success_Zone_sdate_edate(data){
  
 this.showspinner = false;
 this.opdvisitService.patients = [];
 this.opdvisitService.patients = data;
 
 this.opdvisitService.patients.forEach(element => {
   this.newdata.push({"PatientId":element.pkRegId,"RegDate":this.datepipe.transform(element.regDate, "dd/MM/yy"),"FirstName":element.firstName,"LastName":element.lastName,"Email":element.emailAddress,"Address":element.paddress,"City":element['cityname'],"State":element['statename'],"Country":element['countryname'],"Gender":element.sex,"Dob":this.datepipe.transform(element.dob, "dd/MM/yy"),"OldMrNo":element.oldMrno,'MobNo':element.mobileNo})
 });
 //this.dataSource.data = this.opdvisitService.patients;
this.patientcount = this.opdvisitService.patients.length;
this.dataSource.data = this.groupBy(this.groupingColumn,this.newdata,this.reducedGroups);
 }
failed_pat_sdate_edate(err){
this.showspinner = false;
}

groupBy(column:string,data: any[],reducedGroups?: any[]){
  if(!column) return data;
  let collapsedGroups = reducedGroups;
  if(!reducedGroups) collapsedGroups = [];
  const customReducer = (accumulator, currentValue) => {
    let currentGroup = currentValue[column];
    if(!accumulator[currentGroup])
    accumulator[currentGroup] = [{
      groupName: `${column} ${currentValue[column]}`,
      value: currentValue[column], 
      isGroup: true,
      reduced: collapsedGroups.some((group) => group.value == currentValue[column])
    }];
    
    accumulator[currentGroup].push(currentValue);

    return accumulator;
  }
  let groups = data.reduce(customReducer,{});
  let groupArray = Object.keys(groups).map(key => groups[key]);
  let flatList = groupArray.reduce((a,c)=>{return a.concat(c); },[]);

  return flatList.filter((rawLine) => {
      return rawLine.isGroup || 
      collapsedGroups.every((group) => rawLine[column]!=group.value);
    });
}

/**
 * Since groups are on the same level as the data, 
 * this function is used by @input(matRowDefWhen)
 */
isGroup(index, item): boolean{
  return item.isGroup;
}

/**
 * Used in the view to collapse a group
 * Effectively removing it from the displayed datasource
 */
reduceGroup(row){
  row.reduced=!row.reduced;
  if(row.reduced)
    this.reducedGroups.push(row);
  else
    this.reducedGroups = this.reducedGroups.filter((el)=>el.value!=row.value);
  
  // this.buildDataSource();
}

selectpatient(selectedpatient: PatientDetailModel){

this.opdvisitService.getpatientdetails(selectedpatient.pkRegId);
//this.opdvisitService.patientdetails = selectedpatient;


}

exportexcel(): void 
    {
       let element = document.getElementById('content'); 
       this.exportdata.exportxcel(element);
     }

 
  public openPDF():void {
    let DATA = document.getElementById('content');
    this.exportdata.download(DATA);
        
  }
  
  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    this.exportdata.printData(printContents);
    
}
}
